import React, { useRef, useState } from 'react'; 
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import logo from '../../assets/SVG/Clinic Logo.png';

export const ExampleForm = () => {
  const reportRef = useRef(null);
  const [openPreview, setOpenPreview] = useState(false);

  const handleOpenPreview = () => setOpenPreview(true);
  const handleClosePreview = () => setOpenPreview(false);

  const handleDownloadPDF = async () => {
    if (!reportRef.current) return;
    const element = reportRef.current;
    const canvas = await html2canvas(element, { scale: 2, useCORS: true, allowTaint: false });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('Patient_Report.pdf');
  };

  return (
    <>
      <div style={{ padding: '20px', display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" color="primary" onClick={handleOpenPreview}>
          Print
        </Button>
      </div>

      <Dialog open={openPreview} onClose={handleClosePreview} fullWidth maxWidth="lg">
        <DialogTitle>PDF Preview</DialogTitle>
        <DialogContent>
          <div
            ref={reportRef}
            style={{
              padding: '40px',
              background: '#fff',
              color: '#333',
              fontFamily: 'Arial, sans-serif',
              fontSize: '14px',
            }}
          >
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <h2 style={{ margin: 0, fontSize: '24px' }}>ABC Fertility Centre</h2>
                <p style={{ margin: '4px 0' }}>756 University Avenue, Lake Jeniferberg 35967</p>
                <p style={{ margin: '4px 0' }}>46913 Farrell Burg, Treutelslad 64243</p>
                <p style={{ margin: '4px 0' }}>
                  <strong>Email:</strong> ramon_morissette54@gmail.com
                </p>
                <p style={{ margin: '4px 0' }}>
                  <strong>Mobile:</strong> 578-778-3291
                </p>
              </div>
              <div style={{ width: '140px', textAlign: 'right' }}>
                <img
                  src={logo}
                  alt="Clinic Logo"
                  style={{ width: '120px', height: '80px', objectFit: 'contain' }}
                />
              </div>
            </div>

            <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />

            {/* Patient Report Info */}
            <table width="100%" cellPadding="12" style={{ borderCollapse: 'collapse', marginBottom: '30px' }}>
              <tbody>
                {[
                  ['Patient\'s Full Name', 'Ramon Morissette', 'Report No.', 'PNQ-24-54-4567'],
                  ['Gender / Age', 'Female / 32', 'Issued On', '02/06/2023 03:15 PM'],
                  ['Attending Doctor', 'Dr. Ramon Mori', 'Medical Record No.', 'PNQ/000435/W/2023-24'],
                  ['Referred By', 'Dr. Faisal Kumar', 'Report Type', 'Self'],
                  ['Phone Number', '578-778-3291', 'Patient\'s Address', '756 University Avenue']
                ].map((row, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #ccc' }}>
                    {row.map((cell, j) => (
                      <td
                        key={j}
                        style={{
                          border: '1px solid #ccc',
                          textAlign: 'left', // Ensure both key and value are left-aligned
                          padding: '10px',
                        }}
                      >
                        {j % 2 === 0 ? <strong>{cell}</strong> : cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Patient Information Section */}
            <h3 style={{ marginTop: '20px', marginBottom: '10px', fontSize: '18px' }}>Patient Information</h3>
            <table width="100%" cellPadding="12" style={{ borderCollapse: 'collapse' }}>
              <tbody>
                {[
                  ['Patient ID', 'PNQ-24-54-4567', 'Date of Registration', '01/01/2023'],
                  ['Date of Birth', '02/06/1991', 'Marital Status', 'Married'],
                  ['Gender', 'Female', 'Blood Type', 'O+'],
                  ['Occupation', 'Software Engineer', 'Contact Number', '578-778-3291'],
                  ['Email Address', 'ramon_morissette54@gmail.com', 'Nationality', 'American']
                ].map((row, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #ccc' }}>
                    {row.map((cell, j) => (
                      <td
                        key={j}
                        style={{
                          border: '1px solid #ccc',
                          textAlign: 'left', // Ensure both key and value are left-aligned
                          padding: '10px',
                        }}
                      >
                        {j % 2 === 0 ? <strong>{cell}</strong> : cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '20px', textAlign: 'right' }}>
            <Button variant="contained" color="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExampleForm;
